import { CardContent, styled } from '@mui/material';

export const SmartLinksExternalInfoContent = styled(CardContent)`
  flex: 1;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;
